import {
	Dispatch,
	MutableRefObject,
	SetStateAction,
	useEffect,
	useRef,
} from 'react';
import { type BubbleComponentType } from '../../bubble/bubble';
import DivWithInert from '../../div-with-inert';
import ComponentRenderer from '../../component-renderer';
import type {
	ChatMutationType,
	ChatWindowSourceType,
	SourcesType,
} from '../chat-window';
import ChatWindowSources from './chat-window-sources';

const ChatWindowContent = ({
	chatWindowEnd,
	conversation,
	refresh,
	setChatWindowSources,
	chatWindowSources,
	chatWindowExpanded,
	footerRef,
	chatWindowSourcesRef,
}: {
	chatWindowEnd: boolean;
	conversation: BubbleComponentType[];
	refresh: ChatMutationType;
	setChatWindowSources: Dispatch<SetStateAction<ChatWindowSourceType>>;
	chatWindowSources: ChatWindowSourceType;
	chatWindowExpanded: boolean;
	footerRef?: MutableRefObject<HTMLDivElement | null>;
	chatWindowSourcesRef: MutableRefObject<HTMLDivElement | null>;
}) => {
	const contentRef = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		if (contentRef.current) {
			contentRef.current.scrollTop = contentRef.current.scrollHeight;
		}
	}, [conversation]);

	return (
		<div
			className='wlcb-overflow-x-hidden wlcb-bg-white custom-scrollbar wlcb-p-space-100 wlcb-flex wlcb-flex-col wlcb-items-start wlcb-justify-start wlcb-w-full wlcb-h-full'
			ref={contentRef}
		>
			<DivWithInert
				className='wlcb-w-full wlcb-relative'
				inert={chatWindowEnd}
				id='chat-window-content'
				role='log'
				aria-live='polite'
				aria-atomic='false'
			>
				<ComponentRenderer
					components={conversation}
					refresh={refresh}
					setChatWindowSources={setChatWindowSources}
					chatWindowSources={chatWindowSources}
				/>
			</DivWithInert>
			{chatWindowSources.open ? (
				<ChatWindowSources
					ref={chatWindowSourcesRef}
					footerRef={footerRef}
					chatWindowExpanded={chatWindowExpanded}
					setChatWindowSources={setChatWindowSources}
					chatWindowSources={chatWindowSources}
					sources={
						conversation[chatWindowSources?.index as number].props
							.sources as SourcesType[]
					}
				/>
			) : null}
		</div>
	);
};

export default ChatWindowContent;
